import fs from 'fs-extra'
import { copyFiles, fileExists } from './utils'
import ensureLicense from './license-manager'
import path from 'path'

const IGNORE_STR = `.further
node_modules
.DS_Store
.DS_Store?
._*
.Spotlight-V100
.Trashes
ehthumbs.db
Thumbs.db
**/*.log
*.log
`

async function ensureGitIgnore (path) {
    return new Promise (async resolve => {
        const gitIgnoreFile = path + '/.gitignore'
        fs.readFile(gitIgnoreFile, 'utf8').then(async data => {
            if (data.indexOf('.further') < 0) {
                // we add .further to .gitignore in case it isn't already there
                await fs.appendFile(gitIgnoreFile, '.further')
            }
            resolve()
        }).catch(_ => {
            // .gitignore didn't exist...let's create it
            // and add .further (plus some other basic paths) to it
            fs.appendFile(gitIgnoreFile, IGNORE_STR)
            resolve()
        })
    })
}

// ensures .further directory exists
async function ensureMetaDirs (path) {
    return Promise.all([
        fs.ensureDir(path + '/.further/reports'),
        fs.ensureDir(path + '/.further/logs')
    ])
}

async function copyMetaFiles (paths) {
    return copyFiles([
            '.eslintrc.json',
            '.stylelintrc.json'
        ],
        paths.further + '/dist/.meta',
        paths.project + '/.further/')
}

async function setupFurtherDir (paths) {
    return new Promise(async resolve => {
        if (!await fileExists(path.resolve(paths.project, '.further'))) {
            await ensureMetaDirs(paths.project)
            await copyMetaFiles(paths)
        }
        await ensureGitIgnore(paths.project)
        resolve()
    })
}

async function ensureEditorConfig (paths) {
    if (!await fileExists(path.resolve(paths.project, '.editorconfig'))) {
        return copyFiles(
            ['.editorconfig'],
            paths.further + '/dist/.meta/',
            paths.project + '/'
        )
    }
}

async function ensureCOC (paths, pkg) {
    const fileName = 'CODE_OF_CONDUCT.md'
    if (!await fileExists(path.resolve(paths.project, fileName))) {
        return copyFiles(
            [fileName],
            paths.further + '/dist/tpls/',
            paths.project + '/'
        )
    }
}

async function ensureContributeFile (paths, pkg) {
    const fileName = 'CONTRIBUTE.md'
    if (!await fileExists(path.resolve(paths.project, fileName))) {
        return copyFiles(
            [fileName],
            paths.further + '/dist/tpls/',
            paths.project + '/',
            content => {
                // transformation function
                content = content.replace('[year]', (new Date).getFullYear())
                content = content.replace('[projectname]', pkg.name)
                content = content.replace('[author]', pkg.author)
                content = content.replace('[fullname]', pkg.author)
                if (pkg.bugs) {
                    content = content.replace(
                        '[issuespath]',
                        `[issues](${pkg.bugs.url || pkg.bugs})`
                    )
                } else {
                    content = content.replace('[issuespath]', '')
                }
                return content
            }
        )
    }
}

export {
    setupFurtherDir,
    ensureEditorConfig,
    ensureContributeFile,
    ensureCOC,
    ensureLicense
}



// WEBPACK FOOTER //
// ./src/meta-manager.js